<div class="st-icon-container"
     [title]="title"
     assignmentIcon
     [record]="record"
     [itemType]="type"
     [hasValue]="hasValue"
     [hasBorder]="hasBorder">
    <div class="st-icon-content"></div>
</div>